/* "+ Add" dos cards copiados (Complementary products / "Pairs well with" do Dawn dele) — retrabalho 10-15.
   No tema dele o botao abre o modal de quick add `#QuickAdd-<id DELE>`, que nao existe aqui: o clique nao fazia
   nada (nota do operador: "os upsells nao estao funcionando"). Aqui: le /products/<handle>.js da NOSSA loja;
   1 variante -> adiciona direto; varias -> modal compacto (foto, preco, opcoes em pilula, Add to cart).
   Depois do add abre a gaveta (window.clCart). */
(function () {
  'use strict';
  var FMT = null;
  function fmtMoney(c) {
    if (!FMT) { var el = document.querySelector('[data-money]'); FMT = (el && el.getAttribute('data-money')) || 'R$ {{amount_with_comma_separator}}'; }
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    var a = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), b = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return FMT.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b + ',' + v[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, b)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, a)
      .replace(/\{\{\s*amount\s*\}\}/, a + '.' + v[1]);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function handleOf(btn) {
    var u = btn.getAttribute('data-product-url') || '';
    if (!u) { var a = btn.closest('.clx-card-wrapper, .clx-card'); a = a && a.querySelector('a[href*="/products/"]'); u = a ? a.getAttribute('href') : ''; }
    var m = u.match(/\/products\/([^?#/]+)/); return m && m[1];
  }
  function add(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (window.clCart) window.clCart.open(); });
  }
  function busy(btn, on) {
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.toggle('clx-hidden', !on);
  }

  var M = null;
  function close() { if (M) { M.remove(); M = null; document.documentElement.classList.remove('cl-qa-lock'); } }
  function modal(p, color) {
    close();
    var opts = p.options.map(function (o, i) {
      return { name: o.name || o, i: i, values: o.values || p.variants.map(function (v) { return v.options[i]; }).filter(function (x, k, a) { return a.indexOf(x) === k; }) };
    });
    var cur = (p.variants.find(function (v) { return v.available; }) || p.variants[0]).options.slice();
    M = document.createElement('div');
    M.className = 'cl-qa'; M.setAttribute('role', 'dialog'); M.setAttribute('aria-modal', 'true'); M.setAttribute('aria-label', p.title);
    M.innerHTML = '<div class="cl-qa__overlay" data-qa-close></div><div class="cl-qa__panel">' +
      '<button type="button" class="cl-qa__x" data-qa-close aria-label="Close">&times;</button>' +
      '<div class="cl-qa__top"><img class="cl-qa__img" alt=""><div><p class="cl-qa__title">' + esc(p.title) + '</p><p class="cl-qa__price"></p></div></div>' +
      opts.map(function (o) {
        return '<fieldset class="cl-qa__opt"><legend>' + esc(o.name) + ': <span data-qa-sel="' + o.i + '"></span></legend>' +
          o.values.map(function (v) { return '<button type="button" class="cl-qa__pill" data-qa-o="' + o.i + '" data-qa-v="' + esc(v) + '">' + esc(v) + '</button>'; }).join('') + '</fieldset>';
      }).join('') +
      '<button type="button" class="cl-qa__add">Add to cart</button>' +
      '<a class="cl-qa__more" href="/products/' + esc(p.handle) + '">View full details</a></div>';
    document.body.appendChild(M);
    document.documentElement.classList.add('cl-qa-lock');
    var addBtn = M.querySelector('.cl-qa__add');
    if (color) addBtn.style.background = color;
    function v() { return p.variants.find(function (x) { return x.options.every(function (o, i) { return o === cur[i]; }); }); }
    function render() {
      var x = v();
      M.querySelectorAll('.cl-qa__pill').forEach(function (b) {
        var i = +b.getAttribute('data-qa-o'), val = b.getAttribute('data-qa-v');
        b.classList.toggle('is-on', cur[i] === val);
        var test = cur.slice(); test[i] = val;
        var ok = p.variants.some(function (y) { return y.available && y.options.every(function (o, k) { return o === test[k]; }); });
        b.classList.toggle('is-off', !ok);
      });
      M.querySelectorAll('[data-qa-sel]').forEach(function (s) { s.textContent = cur[+s.getAttribute('data-qa-sel')]; });
      M.querySelector('.cl-qa__price').innerHTML = x ? (x.compare_at_price > x.price ? '<s>' + fmtMoney(x.compare_at_price) + '</s> ' : '') + fmtMoney(x.price) : '';
      var img = (x && x.featured_image && x.featured_image.src) || p.featured_image;
      if (img) M.querySelector('.cl-qa__img').src = (img.indexOf('//') === 0 ? 'https:' + img : img).replace(/(\.\w+)(\?|$)/, '_300x$1$2');
      addBtn.disabled = !(x && x.available);
      addBtn.textContent = x && x.available ? 'Add to cart' : 'Sold out';
    }
    M.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) { close(); return; }
      var b = e.target.closest('.cl-qa__pill');
      if (b) { cur[+b.getAttribute('data-qa-o')] = b.getAttribute('data-qa-v'); render(); return; }
      if (e.target.closest('.cl-qa__add')) {
        var x = v(); if (!x) return;
        addBtn.disabled = true;
        add(x.id, 1).then(close).catch(function (err) { addBtn.disabled = false; if (err && err.description) alert(err.description); });
      }
    });
    render();
    addBtn.focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.clx-quick-add__submit');
    if (!btn || btn.closest('form[action*="/cart/add"]')) return;   // card de 1 variante com form proprio: o cl-cart.js cuida
    var h = handleOf(btn); if (!h) return;
    e.preventDefault(); e.stopImmediatePropagation();
    busy(btn, true);
    var color = getComputedStyle(btn).backgroundColor;
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var av = p.variants.filter(function (v) { return v.available; });
        if (p.variants.length === 1 || (p.options.length === 1 && /^title$/i.test(p.options[0].name || p.options[0]))) return add((av[0] || p.variants[0]).id, 1);
        modal(p, color && color !== 'rgba(0, 0, 0, 0)' ? color : null);
      })
      .catch(function () { location.href = '/products/' + h; })
      .then(function () { busy(btn, false); });
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && M) close(); });
})();
